const LIGHTING_PERF_PARAM = 'lightingPerf';

function parsePerfFlag(search = window.location.search) {
  const raw = new URLSearchParams(search).get(LIGHTING_PERF_PARAM);
  if (raw == null) return false;
  const normalized = String(raw).trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'on';
}

export function getLightingQuality(search = window.location.search) {
  const perfMode = parsePerfFlag(search);
  return {
    perfMode,
    renderer: {
      pixelRatioCap: perfMode ? 1.25 : 1.5,
      toneMappingExposure: 1.2,
    },
    proceduralAccent: {
      // Keep all accent lights active; only cap expensive shadow casters.
      maxShadowedPointLights: perfMode ? 1 : 2,
      pointShadowMapSize: perfMode ? 256 : 512,
      pointShadowCameraNear: 0.1,
      pointShadowCameraFar: 14,
      pointShadowBias: -0.0005,
      pointShadowNormalBias: perfMode ? 0.03 : 0.02,
    },
    cinematic: {
      bloom: {
        enabled: true,
        strength: perfMode ? 0.3 : .4,
        radius: perfMode ? 0.4 : 0.3,
        threshold: perfMode ? 0.28 : 0.29,
      },
      dust: {
        enabled: true,
        count: perfMode ? 120 : 190,
        opacity: perfMode ? 0.06 : 0.09,
      },
      floorGlow: {
        enabled: true,
        baseOpacity: perfMode ? 0.12 : 0.16,
        maxOpacity: perfMode ? 0.35 : 0.48,
        radiusMul: perfMode ? 0.88 : 1.05,
      },
    },
  };
}

